import { Theme } from "@amx/ux-twoui-theming";
import React from "react";
import { isRTL } from "../../../../styles";
import { ChevronPosition } from "./DrawerHeaderChevron";

export const getChevronIconStyles = (theme: Theme, drawerOpen: boolean, chevronPosition: ChevronPosition): React.CSSProperties => {
    return {
        transform: chevronPosition === "start" ? getStartChevronTransformValue(drawerOpen) : getEndChevronTransformValue(drawerOpen),
        transition: "transform 0.1s linear 0s",
        fontSize: "16px",
        fontFamily: "AMC Icons",
        color: theme.palette.neutralSecondary
    };
};

export const getStartChevronTransformValue = (drawerOpen: boolean): string => {
    const rtl = isRTL();

    let transformValue = "rotate(0deg)";

    if (drawerOpen && rtl) {
        transformValue = "rotate(-90deg)";
    }
    if (drawerOpen && !rtl) {
        transformValue = "rotate(90deg)";
    }

    return transformValue;
};

export const getEndChevronTransformValue = (drawerOpen: boolean): string => {
    const rtl = isRTL();

    let transformValue = "rotate(0deg)";

    if (drawerOpen && rtl) {
        transformValue = "rotate(-180deg)";
    }
    if (drawerOpen && !rtl) {
        transformValue = "rotate(180deg)";
    }

    return transformValue;
};
